import React from "react";

const CheckmarkDoneSharp = ({ color, height, width }) => (
  <svg
    class=""
    height={height}
    width={width}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      fill="none"
      stroke={color}
      stroke-linecap="square"
      stroke-miterlimit="10"
      stroke-width="44"
      d="M465 127L241 384l-92-92M140 385l-93-93M363 127L236 273"
    ></path>
  </svg>
);

export default CheckmarkDoneSharp;
